export const REACT_APP_MAPS_API_KEY = process.env.REACT_APP_MAPS_API_KEY;

export const AUTH_REGION = process.env.REACT_APP_AUTH_REGION;
export const AUTH_USER_POOL_ID = process.env.REACT_APP_AUTH_USER_POOL_ID;
export const AUTH_USER_POOL_WEB_CLIENT_ID = process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID;
export const AUTH_USER_POOL_SECRET = process.env.REACT_APP_AUTH_USER_POOL_SECRET;
export const AUTH_COOKIE_DOMAIN = process.env.REACT_APP_AUTH_COOKIE_DOMAIN;
export const AUTH_OAUTH_DOMAIN = process.env.REACT_APP_AUTH_OAUTH_DOMAIN;
export const AUTH_REDIRECT_SIGN_IN = process.env.REACT_APP_AUTH_REDIRECT_SIGN_IN;
export const AUTH_REDIRECT_SIGN_OUT = process.env.REACT_APP_AUTH_REDIRECT_SIGN_OUT;
export const REACT_APP_WEBSOCKETPORT = process.env.REACT_APP_WEBSOCKETPORT;
export const REACT_APP_MIDDLEWARE_URL = process.env.REACT_APP_MIDDLEWARE_URL;
export const REACT_APP_MIDDLEWARE_COMMAND_URL = process.env.REACT_APP_MIDDLEWARE_COMMAND_URL;